import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    displayMode: '',
    triggerType: 'delay',
    triggerDelay: 5,
    popupFrequency: 1,
    stickyText: '',
    stickyButtonText: '',
    stickyPosition: 'bottom-bar',
    ctaText: '',
    ctaUrl: '',
    sourceMode: 'link',
    discountId: null,
    activeItem: null,
  },
  blockDesign: {
    layout: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const discountBlockSlice = createSlice({
  name: 'discountBlock',
  initialState,
  reducers: {
    discountBlockStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent = {}, blockDesign = {} } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        displayMode: blockContent.displayMode ?? '',
        triggerType: blockContent.triggerType ?? 'delay',
        triggerDelay: blockContent.triggerDelay ?? 5,
        popupFrequency: blockContent.popupFrequency ?? 1,
        stickyText: blockContent.stickyText ?? '',
        stickyButtonText: blockContent.stickyButtonText ?? '',
        stickyPosition: blockContent.stickyPosition ?? 'bottom-bar',
        ctaText: blockContent.ctaText ?? '',
        ctaUrl: blockContent.ctaUrl ?? '',
        sourceMode: blockContent.sourceMode ?? 'link',
        discountId: blockContent.discountId ?? null,
        activeItem: blockContent.activeItem ?? null,
      };
      state.blockDesign = {
        layout: blockDesign.layout ?? 'feed',
      };
    },
    discountBlockClear: () => initialState,
    discountBlockUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    discountBlockUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    discountBlockUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    discountBlockUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const {
  discountBlockStore,
  discountBlockClear,
  discountBlockUpdateIsLoading,
  discountBlockUpdateIsActive,
  discountBlockUpdateBlockContent,
  discountBlockUpdateBlockDesign,
} = discountBlockSlice.actions;

export const selectDiscountBlockIsLoading = (state) => state.discountBlock.isLoading;
export const selectDiscountBlockIsActive = (state) => state.discountBlock.isActive;
export const selectDiscountBlockId = (state) => state.discountBlock.id;
export const selectDiscountBlockUID = (state) => state.discountBlock.uid;
export const selectDiscountBlockSID = (state) => state.discountBlock.sid;
export const selectDiscountBlockContent = (state) => state.discountBlock.blockContent;
export const selectDiscountBlockDesign = (state) => state.discountBlock.blockDesign;
export const selectDiscountBlockItemDesign = (state) => state.discountBlock.itemDesign;
export const selectDiscountBlockContainerDesign = (state) => state.discountBlock.containerDesign;

export default discountBlockSlice.reducer;
